/**
 * W66.W6 — Account intel: 8-row key/value table.
 * Fields: Industry, Revenue band, Employees, HQ, Email pattern,
 *         Anchor offer awareness, Fiscal year, Procurement timing.
 */

import React from "react";

interface IntelTableProps {
  planData: Record<string, any>;
}

const INTEL_ROWS: Array<{ key: string; label: string }> = [
  { key: "industry", label: "Industry" },
  { key: "revenue_band", label: "Revenue band" },
  { key: "employees", label: "Employees" },
  { key: "hq", label: "HQ" },
  { key: "email_pattern", label: "Email pattern" },
  { key: "anchor_offer_awareness", label: "Profit+ awareness" },
  { key: "fiscal_year", label: "Fiscal year" },
  { key: "procurement_timing", label: "Procurement timing" },
];

export default function IntelTable({ planData }: IntelTableProps) {
  const intel = planData.intel ?? {};

  return (
    <section style={{ marginBottom: 28 }}>
      <h2
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: "#374151",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          margin: "0 0 10px",
          borderBottom: "1px solid #E5E7EB",
          paddingBottom: 6,
        }}
      >
        Account Intel
      </h2>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 13,
        }}
      >
        <tbody>
          {INTEL_ROWS.map(({ key, label }, i) => {
            const val = intel[key];
            return (
              <tr
                key={key}
                style={{
                  background: i % 2 === 0 ? "#F9FAFB" : "#FFFFFF",
                }}
              >
                <td
                  style={{
                    padding: "8px 12px",
                    fontWeight: 600,
                    color: "#374151",
                    width: 180,
                    borderBottom: "1px solid #E5E7EB",
                    verticalAlign: "top",
                    whiteSpace: "nowrap",
                  }}
                >
                  {label}
                </td>
                <td
                  style={{
                    padding: "8px 12px",
                    color: val ? "#111827" : "#9CA3AF",
                    fontStyle: val ? "normal" : "italic",
                    borderBottom: "1px solid #E5E7EB",
                    lineHeight: 1.4,
                  }}
                >
                  {val ?? "TBD"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
